import React from 'react';
import { manufacturers, certifications } from '../../../config/homepagePartners';

const CertBadge = ({ label }) => (
  <div
    className="flex items-center justify-center px-4 py-2.5 rounded-lg"
    style={{
      minWidth: '140px',
      minHeight: '52px',
      backgroundColor: 'rgba(7,176,233,0.06)',
      border: '1px solid rgba(7,176,233,0.20)',
    }}
  >
    <span
      className="font-poppins font-semibold text-xs uppercase tracking-wide text-center leading-tight"
      style={{ color: '#000150' }}
    >
      {label}
    </span>
  </div>
);

const PartnerLogosStrip = () => (
  <div className="border-t border-gray-100 pt-8 lg:pt-10">
    <p className="text-center text-xs font-semibold text-gray-400 uppercase tracking-widest mb-6">
      Trusted partners
    </p>
    <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-5 lg:gap-x-10">
      {manufacturers.map((m) => (
        <img
          key={m.name}
          src={m.imageUrl}
          alt={`${m.name} logo`}
          className="h-10 lg:h-14 w-auto object-contain opacity-75 hover:opacity-100 transition-opacity"
          loading="lazy"
        />
      ))}
      {certifications.map((c) =>
        c.imageUrl ? (
          <img
            key={c.label}
            src={c.imageUrl}
            alt={c.label}
            className="h-10 lg:h-14 w-auto object-contain opacity-75 hover:opacity-100 transition-opacity"
            loading="lazy"
          />
        ) : (
          <CertBadge key={c.label} label={c.label} />
        )
      )}
    </div>
  </div>
);

export default PartnerLogosStrip;
